import { LEGAL_DOCUMENTS } from './documents.config';
import { LegalDocumentPage } from './legal-document-page';
import { resolveLocale } from './locale';

/** Unauthenticated /privacy-policy route (ESCLOUD-78 / ESCLOUD-181). */
export function PrivacyPolicyPage() {
    const config = LEGAL_DOCUMENTS.privacyPolicy;
    const locale = resolveLocale(config.locales);
    return (
        <LegalDocumentPage
            title={config.titles[locale]}
            version={config.version}
            effectiveDate={config.effectiveDate}
            contentType="privacy-policy"
            locale={locale}
        />
    );
}
